import { ChannelSchema } from "@redotech/redo-model/marketplace/channels";
import * as z from "zod/v4";

const ChannelIntegrationSchema_ = z.object({
  id: z.string(),
});

export interface ChannelIntegration
  extends z.infer<typeof ChannelIntegrationSchema_> {}

export const getAvailableChannels = {
  name: "getAvailableChannels" as const,
  input: z.object({}),
  output: z.object({
    channels: z.array(
      z.object({
        channel: ChannelSchema,
        integrations: z.array(ChannelIntegrationSchema_),
      }),
    ),
  }),
};
